
import Editor from "./editor";
export default Editor.extend({});
